import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import _ from 'lodash';
import PublicInterviewSchedule from './PublicInterviewSchedule';

class PublicInterviewInvite extends DomainObject {
  companyName;
  startDate;
  endDate;
  interviewSchedule;
  bookableSlots = [];
  booked;
  eventStartsAt;

  _relations = {
    interviewSchedule: PublicInterviewSchedule,
    _dates: ['eventStartsAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      companyName: observable,
      startDate: observable,
      endDate: observable,
      interviewSchedule: observable,
      bookableSlots: observable,
      booked: observable,
      eventStartsAt: observable,
      logoUrl: computed
    });

    this.merge(other);
  }

  get logoUrl() {
    return _.get(this, 'links.companyLogo');
  }
}

export default PublicInterviewInvite;
